import { cx } from "shared/utils";

export const TeamTriedFirstBadge = ({
  className = ""
}: {
  className?: string;
}) => (
  <span
    className={cx(
      "inline-flex items-center whitespace-nowrap rounded-full bg-primary-20 px-2.5 py-0.5 text-[13px] font-medium leading-4 text-primary-500",
      className
    )}
  >
    Team tried first
  </span>
);
